import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { TableState } from '../../components/Table/Table'

export const initialState: TableState = {
  columnVisibility: {},
  columnOrder: [],
  columnFilters: [],
  globalFilter: '',
  sorting: [],
  pageIndex: 0,
}

export const currenciesTableSlice = createSlice({
  name: 'currenciesTable',
  initialState,
  reducers: {
    setCurrenciesTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const transfersTableSlice = createSlice({
  name: 'transfersTable',
  initialState,
  reducers: {
    setTransfersTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const fundDepositsTableSlice = createSlice({
  name: 'fundDepositsTable',
  initialState,
  reducers: {
    setFundDepositsTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setFundDepositsTableState } = fundDepositsTableSlice.actions
export const fundDepositsTableReducer = fundDepositsTableSlice.reducer

export const clientsTableSlice = createSlice({
  name: 'clientsTable',
  initialState,
  reducers: {
    setClientsTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const systemWalletsTableSlice = createSlice({
  name: 'systemWalletsTable',
  initialState,
  reducers: {
    setSystemWalletsTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const bankAccountsTableSlice = createSlice({
  name: 'bankAccountsTable',
  initialState,
  reducers: {
    setBankAccountsTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const networksTableSlice = createSlice({
  name: 'networksTable',
  initialState,
  reducers: {
    setNetworksTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setCurrenciesTableState } = currenciesTableSlice.actions
export const currenciesTableReducer = currenciesTableSlice.reducer

export const { setTransfersTableState } = transfersTableSlice.actions
export const transfersTableReducer = transfersTableSlice.reducer

export const { setClientsTableState } = clientsTableSlice.actions
export const clientsTableReducer = clientsTableSlice.reducer

export const { setSystemWalletsTableState } = systemWalletsTableSlice.actions
export const systemWalletsTableReducer = systemWalletsTableSlice.reducer

export const { setBankAccountsTableState } = bankAccountsTableSlice.actions
export const bankAccountsTableReducer = bankAccountsTableSlice.reducer

export const { setNetworksTableState } = networksTableSlice.actions
export const networksTableReducer = networksTableSlice.reducer

export const feeStructuresTableSlice = createSlice({
  name: 'feeStructuresTable',
  initialState,
  reducers: {
    setFeeStructuresTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setFeeStructuresTableState } = feeStructuresTableSlice.actions
export const feeStructuresTableReducer = feeStructuresTableSlice.reducer

export const affiliatePartnersTableSlice = createSlice({
  name: 'affiliatePartnersTable',
  initialState,
  reducers: {
    setAffiliatePartnersTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setAffiliatePartnersTableState } =
  affiliatePartnersTableSlice.actions
export const affiliatePartnersTableReducer = affiliatePartnersTableSlice.reducer

export const teamTableSlice = createSlice({
  name: 'teamTable',
  initialState,
  reducers: {
    setTeamTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setTeamTableState } = teamTableSlice.actions
export const teamTableReducer = teamTableSlice.reducer

export const veliWealthManagersTableSlice = createSlice({
  name: 'veliWealthManagersTable',
  initialState,
  reducers: {
    setVeliWealthManagersTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setVeliWealthManagersTableState } =
  veliWealthManagersTableSlice.actions
export const veliWealthManagersTableReducer =
  veliWealthManagersTableSlice.reducer

export const veliClientsTableSlice = createSlice({
  name: 'veliClientsTable',
  initialState,
  reducers: {
    setVeliClientsTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setVeliClientsTableState } = veliClientsTableSlice.actions
export const veliClientsTableReducer = veliClientsTableSlice.reducer

export const affiliateStatsMonthlyTableSlice = createSlice({
  name: 'affiliateStatsMonthlyTable',
  initialState,
  reducers: {
    setAffiliateStatsMonthlyTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setAffiliateStatsMonthlyTableState } =
  affiliateStatsMonthlyTableSlice.actions
export const affiliateStatsMonthlyTableReducer =
  affiliateStatsMonthlyTableSlice.reducer

export const bookkeepingTableSlice = createSlice({
  name: 'bookkeepingTable',
  initialState,
  reducers: {
    setBookkeepingTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setBookkeepingTableState } = bookkeepingTableSlice.actions
export const bookkeepingTableReducer = bookkeepingTableSlice.reducer

export const finanstilsynetSamplingTableSlice = createSlice({
  name: 'finanstilsynetSamplingTable',
  initialState,
  reducers: {
    setFinanstilsynetSamplingTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setFinanstilsynetSamplingTableState } =
  finanstilsynetSamplingTableSlice.actions
export const finanstilsynetSamplingTableReducer =
  finanstilsynetSamplingTableSlice.reducer

export const finanstilsynetBreakdownTableSlice = createSlice({
  name: 'finanstilsynetBreakdownTable',
  initialState,
  reducers: {
    setFinanstilsynetBreakdownTableState: (
      state: TableState,
      action: PayloadAction<TableState>
    ) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setFinanstilsynetBreakdownTableState } =
  finanstilsynetBreakdownTableSlice.actions
export const finanstilsynetBreakdownTableReducer =
  finanstilsynetBreakdownTableSlice.reducer
